/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from '@atproto/lex'
import * as LabelDefs from './..\\..\\..\\com\\atproto\\label\\defs.defs.js'
import * as ActorDefs from './..\\..\\..\\app\\bsky\\actor\\defs.defs.js'

const $nsid = 'chat.bsky.actor.defs'

type $nsid = typeof $nsid

export { $nsid }

type MemberRole = 'owner' | 'standard' | l.UnknownString

export type { MemberRole }

const memberRole = /*#__PURE__*/ l.string<{
  knownValues: ['owner', 'standard']
}>()

export { memberRole }

/** A current group convo member. */
type GroupConvoMember = {
  $type?: 'chat.bsky.actor.defs#groupConvoMember'

  /**
   * The member's role within this conversation. Only present in group conversation member lists.
   */
  role: MemberRole

  /**
   * Who added this member. Only present if the member was added (instead of joining via link).
   */
  addedBy?: ProfileViewBasic
}

export type { GroupConvoMember }

/** A current group convo member. */
const groupConvoMember = /*#__PURE__*/ l.typedObject<GroupConvoMember>(
  $nsid,
  'groupConvoMember',
  /*#__PURE__*/ l.object({
    role: /*#__PURE__*/ l.ref<MemberRole>((() => memberRole) as any),
    addedBy: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.ref<ProfileViewBasic>((() => profileViewBasic) as any),
    ),
  }),
)

export { groupConvoMember }

type ProfileViewBasic = {
  $type?: 'chat.bsky.actor.defs#profileViewBasic'
  did: l.DidString

  /**
   * Union field that has data specific to different kinds of convos.
   */
  kind?:
    | l.$Typed<DirectConvoMember>
    | l.$Typed<GroupConvoMember>
    | l.$Typed<PastGroupConvoMember>
    | l.Unknown$TypedObject
  avatar?: l.UriString
  handle: l.HandleString
  labels?: LabelDefs.Label[]
  viewer?: ActorDefs.ViewerState
  createdAt?: l.DatetimeString
  associated?: ActorDefs.ProfileAssociated
  displayName?: string

  /**
   * Set to true when the actor cannot actively participate in conversations
   */
  chatDisabled?: boolean
  verification?: ActorDefs.VerificationState
}

export type { ProfileViewBasic }

const profileViewBasic = /*#__PURE__*/ l.typedObject<ProfileViewBasic>(
  $nsid,
  'profileViewBasic',
  /*#__PURE__*/ l.object({
    did: /*#__PURE__*/ l.string({ format: 'did' }),
    kind: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.typedUnion(
        [
          /*#__PURE__*/ l.typedRef<DirectConvoMember>(
            (() => directConvoMember) as any,
          ),
          /*#__PURE__*/ l.typedRef<GroupConvoMember>(
            (() => groupConvoMember) as any,
          ),
          /*#__PURE__*/ l.typedRef<PastGroupConvoMember>(
            (() => pastGroupConvoMember) as any,
          ),
        ],
        false,
      ),
    ),
    avatar: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.string({ format: 'uri' })),
    handle: /*#__PURE__*/ l.string({ format: 'handle' }),
    labels: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.array(
        /*#__PURE__*/ l.ref<LabelDefs.Label>((() => LabelDefs.label) as any),
      ),
    ),
    viewer: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.ref<ActorDefs.ViewerState>(
        (() => ActorDefs.viewerState) as any,
      ),
    ),
    createdAt: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.string({ format: 'datetime' }),
    ),
    associated: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.ref<ActorDefs.ProfileAssociated>(
        (() => ActorDefs.profileAssociated) as any,
      ),
    ),
    displayName: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.string({ maxLength: 640, maxGraphemes: 64 }),
    ),
    chatDisabled: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.boolean()),
    verification: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.ref<ActorDefs.VerificationState>(
        (() => ActorDefs.verificationState) as any,
      ),
    ),
  }),
)

export { profileViewBasic }

type DirectConvoMember = { $type?: 'chat.bsky.actor.defs#directConvoMember' }

export type { DirectConvoMember }

const directConvoMember = /*#__PURE__*/ l.typedObject<DirectConvoMember>(
  $nsid,
  'directConvoMember',
  /*#__PURE__*/ l.object({}),
)

export { directConvoMember }

/** A past group convo member. */
type PastGroupConvoMember = {
  $type?: 'chat.bsky.actor.defs#pastGroupConvoMember'
}

export type { PastGroupConvoMember }

/** A past group convo member. */
const pastGroupConvoMember = /*#__PURE__*/ l.typedObject<PastGroupConvoMember>(
  $nsid,
  'pastGroupConvoMember',
  /*#__PURE__*/ l.object({}),
)

export { pastGroupConvoMember }
